var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Button, Loading, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
import { useCallout } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { PREVIEW_FORMATS } from "../api/previewService";
import { useRecordPreview, } from "../hooks/useRecordPreview";
import { writeToClipboard } from "../utils/clipboard";
import css from "./RecordPreviewModal.module.css";
var FILE_EXTENSION = {
    M21: "xml",
    ONIX: "xml",
    JSON: "json",
    RDF: "rdf",
};
var MIME_TYPE = {
    M21: "application/xml",
    ONIX: "application/xml",
    JSON: "application/json",
    RDF: "application/rdf+xml",
};
/**
 * Modal that renders a generated record preview of a title or product in the
 * selected format (M21 / ONIX / JSON / RDF), with copy-to-clipboard and download.
 */
export var RecordPreviewModal = function (_a) {
    var open = _a.open, target = _a.target, onClose = _a.onClose;
    var formatMessage = useIntl().formatMessage;
    var callout = useCallout();
    var _b = useState("M21"), format = _b[0], setFormat = _b[1];
    var _c = useState(false), copied = _c[0], setCopied = _c[1];
    var _d = useRecordPreview(target, format, open), data = _d.data, isLoading = _d.isLoading, isError = _d.isError, error = _d.error;
    var handleSelectFormat = function (next) {
        setFormat(next);
        setCopied(false);
    };
    var handleCopy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!data)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, writeToClipboard(data)];
                case 2:
                    _b.sent();
                    setCopied(true);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setCopied(false);
                    callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                        type: "error",
                        message: formatMessage({ id: "ui-br-agency.preview.copy.error" }),
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDownload = function () {
        if (!data)
            return;
        var blob = new Blob([data], { type: MIME_TYPE[format] });
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = "".concat(target.kind, "-").concat(target.id, ".").concat(FILE_EXTENSION[format]);
        link.click();
        URL.revokeObjectURL(url);
    };
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", onClick: handleCopy, disabled: !data || isLoading },
            React.createElement(FormattedMessage, { id: copied
                    ? "ui-br-agency.preview.button.copied"
                    : "ui-br-agency.preview.button.copy" })),
        React.createElement(Button, { buttonStyle: "default", onClick: handleDownload, disabled: !data || isLoading },
            React.createElement(FormattedMessage, { id: "ui-br-agency.preview.button.download" })),
        React.createElement(Button, { buttonStyle: "default", onClick: onClose },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.close" }))));
    return (React.createElement(Modal, { open: open, onClose: onClose, label: formatMessage({ id: "ui-br-agency.preview.modal.heading" }), footer: footer, size: "large", dismissible: true },
        React.createElement("div", { className: css.formatBar, role: "tablist" }, PREVIEW_FORMATS.map(function (f) { return (React.createElement(Button, { key: f, role: "tab", "aria-selected": f === format, buttonStyle: f === format ? "primary" : "default", onClick: function () { return handleSelectFormat(f); }, marginBottom0: true }, f)); })),
        isLoading && React.createElement(Loading, null),
        isError && (React.createElement(MessageBanner, { type: "error" }, (error === null || error === void 0 ? void 0 : error.message) ||
            formatMessage({ id: "ui-br-agency.preview.error" }))),
        !isLoading && !isError && (React.createElement("pre", { className: css.content, "data-test-preview-content": true }, data))));
};
